export const searchOnMapIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17.106 15.418c2.863-4.6-.558-8.958-4.065-9.468L13 5.453V3L7 6v2.497s-2.258 3.678-.018 7.074L7 17l.82-.444c.648.683 1.654 1.155 2.182 1.344L6 20l-6-4V0l6 4 8-4 6 4 .055 14.36m-4.693-1.996a5.447 5.447 0 1 1 .96-.96l3.643 3.63-.967.967-3.63-3.636zm-3.337-.218a4.087 4.086 0 1 0 0-8.171 4.087 4.086 0 0 0 0 8.171z"/></svg>`,
  name: 'search-on-map',
};
